import { combineReducers, configureStore, Middleware } from '@reduxjs/toolkit';
import createSagaMiddleware, { SagaMiddleware } from 'redux-saga';

import { aromaReducer, SLICE_AROMA_NAME } from '../features/aroma/store';
import { dataSourcesReducer, SLICE_DATASOURCE_NAME } from '../features/datasources/store';
import { projectWorkflowReducer, SLICE_PROJECT_WORKFLOW } from '../features/project/store';
import rootSaga from './root-saga';

const rootReducer = combineReducers({
  [SLICE_DATASOURCE_NAME]: dataSourcesReducer,
  [SLICE_AROMA_NAME]: aromaReducer,
  [SLICE_PROJECT_WORKFLOW]: projectWorkflowReducer,
});

const sagaMiddleware: SagaMiddleware<object> = createSagaMiddleware();

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false, serializableCheck: false }).prepend(sagaMiddleware as Middleware),
});

sagaMiddleware.run(rootSaga);

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
